import _get from 'lodash/get'

/* @ngInject */
export default class EmulatorContactController {
    constructor(
        EventEmitter,
        $scope,
        $state,
        $timeout,
    ) {
        this.EventEmitter = EventEmitter;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.event = {
            contact: {
                state: _get(this.device, 'reported.contact.state', 'OPEN')
            }
        }
    }

    get prettyState() {
        if (this.event.contact.state === "OPEN") {
            return "Open";
        }
        if (this.event.contact.state === "CLOSED") {
            return "Closed";
        }
        return "";
    }

    sendContactEvent() {
        this.onPublishEvent(
            this.EventEmitter({
                event: this.event
            })
        )
    }
}